import { render, staticRenderFns } from "./TravelPieShare.vue?vue&type=template&id=408c7272&"
import script from "./TravelPieShare.vue?vue&type=script&lang=js&"
export * from "./TravelPieShare.vue?vue&type=script&lang=js&"
import style0 from "./TravelPieShare.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TravelPieShare.vue"
export default component.exports